export const HOME = {
  // Nav
  nav: "zynthoro-nav",
  navLogo: "nav-logo",
  navPlatform: "nav-platform",
  navPricing: "nav-pricing",
  navEnterprise: "nav-enterprise",
  navAbout: "nav-about",
  navCta: "nav-cta-start-trial",
  emergentLink: "emergent-link",

  // Hero
  hero: "section-hero",
  heroHeadline: "hero-headline",
  heroSubheadline: "hero-subheadline",
  heroPrimaryCta: "hero-cta-presale",
  heroSecondaryCta: "hero-cta-watch-demo",

  // Sections
  socialProof: "section-social-proof",
  why: "section-why",
  domains: "section-domains",
  pricing: "section-pricing",
  assist: "section-assist",
  comparison: "section-comparison",
  production: "section-production",
  voiceAI: "section-voice-ai",
  presaleCta: "section-presale-cta",
  presaleCtaButton: "presale-cta-button",
  footer: "footer",

  // Presale dialog
  presaleDialog: "presale-dialog",
  presaleNameInput: "presale-name-input",
  presaleEmailInput: "presale-email-input",
  presaleCompanyInput: "presale-company-input",
  presalePlanSelect: "presale-plan-select",
  presaleSubmit: "presale-submit",
  presaleSuccess: "presale-success",
};
